// import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Backdrop, Checkbox, CircularProgress, FormControl, FormControlLabel, FormGroup, FormLabel, InputAdornment, InputLabel, MenuItem, Select } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { FormikTextField } from '../../CommonComponents/FormField.js';
import React, { Component } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { ccountry, currentTenant, einvoice, taxtype, userid } from "../../Common/Credentials.js";
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";
import MasterService from "../MasterService.js";
import CustomerService from "./CustomerService.js";
import SalesServices from "../../Sales/SalesServices.js";
import Swal from "sweetalert2";
import SettingsServices from "../../Settings/SettingsServices.js";
import { accounts } from "../../Common/Products.js";
import IOSSwitch from "../../CommonComponents/IOSSwitch.js";
import NewLedgerService from "../../Accounts/Ledgers/NewLedgerService.js";
import SubHeadsService from "../../Accounts/Subhead/SubHeadsService.js";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";
import AutoCompeteField from "../../NewUI/NewComponents/AutoCompeteField.jsx";
import SelectField from "../../NewUI/NewComponents/SelectField.jsx";
import PhoneInput from "../../Component/PhoneInput.jsx";

class NewCustomer extends Component {
  constructor(props) {
    super(props);
    const { name } = this.props.location.state;
    this.state = {
      // type: 'password',
      name: name,
      id: "",
      StateId: "",
      state: '',
      CountryId: "",
      country: '',
      CityId: "",
      city: '',
      message: "",
      customcustomerid: '',
      countryprefix: ["91 IND", "93 AFG"],
      CountryData: [],
      StateData: [],
      CityData: [],
      statecode: '',
      item: [],
      companyname: "",
      contactname: "",
      prefix: "",
      contactnumber: "",
      alternatephonecode: "",
      alternatenumber: '',
      email: "",
      address: "",
      address2: "",
      pan: "",
      gstin: "",
      validgstin: false,
      zip: "",
      error: "",
      loader: false,
      currencylist: [],
      currency: '',
      phonecode: '',
      TaxtypeData: [],
      taxtype: taxtype,
      registrationtype: 'Unregistered',
      Registrationtypes: [{ "id": 0, "type": "Registered" }, { "id": 1, "type": "Unregistered" }, { "id": 2, "type": "Composition" }, { "id": 3, "type": "SEZ (Special economic zone)" }, { "id": 4, "type": "Overseas" }],
      // appmaster:false,
      // accounts:false,
      // inventory:false,
      // sales:false,
      // purchase:false,
      gstvaldloader: false,
      einvoice: false,
      createledger: false,
      opereq: false,
      opetype: false,
      amount: 0,
      types: ["Domestic", "International"],
      type: null,
      masterLedgers: [],
      ledGroups: [],
      ledgerid: null,
      customertype: "Regular"
    };
    this.onSubmit = this.onSubmit.bind(this);
    //  this.handleChange=this.handleChange.bind(this)
    this.validate = this.validate.bind(this);
  }

  // handleProductChange = (e) => {
  //   this.setState({ ...this.state, [e.target.name]: e.target.checked });
  // };

  onSubmit(values) {
    this.setState({ loader: true });


    let data = {
      tenantId: currentTenant,
      reqparam: this.state.gstin,
    }
    let newCustomer = {
      companyname: values.companyname,
      contactname: values.contactname,
      contactnumber: values.contactnumber.replace(/[^0-9]+/ig, ""),
      email: values.email,
      address: values.address,
      address2: values.address2,
      pan: values.pan?.toUpperCase(),
      gstin: values.gstin?.toUpperCase(),
      zip: values.zip,
      country: this.state.CountryId,
      countryname: this.state.country,
      state: this.state.StateId,
      statename: this.state.state,
      statecode: this.state.statecode,
      city: this.state.CityId,
      cityname: this.state.city,
      updatedby: userid,
      tenantId: currentTenant,
      createdby: userid,
      currency: this.state.currency,
      alternatenumber: this.state.alternatenumber === undefined || this.state.alternatenumber === null ? '' : this.state.alternatenumber.replace(/[^0-9]+/ig, ""),
      phonecode: this.state.phonecode,
      taxtype: taxtype,
      registrationtype: this.state.registrationtype,
      customertype: this.state.customertype,

      // appmaster:this.state.appmaster,
      // accounts:this.state.accounts,
      // inventory:this.state.inventory,
      // sales:this.state.sales,
      // purchase:this.state.purchase
    };
    let updateCustomer = {
      id: this.state.id,
      companyname: values.companyname,
      contactname: values.contactname,
      contactnumber: values.contactnumber.replace(/[^0-9]+/ig, ""),
      email: values.email,
      address: values.address,
      address2: values.address2,
      pan: values.pan?.toUpperCase(),
      gstin: values.gstin?.toUpperCase(),
      zip: values.zip,
      country: this.state.CountryId,
      countryname: this.state.country,
      state: this.state.StateId,
      statename: this.state.state,
      statecode: this.state.statecode,
      city: this.state.CityId,
      cityname: this.state.city,
      updatedby: userid,
      currency: this.state.currency,
      alternatenumber: this.state.alternatenumber === undefined || this.state.alternatenumber === null ? '' : this.state.alternatenumber.replace(/[^0-9]+/ig, ""),
      customcustomerid: this.state.customcustomerid,
      phonecode: this.state.phonecode,
      taxtype: taxtype,
      registrationtype: this.state.registrationtype,
      ledgerid: this.state.ledgerid,
      customertype: this.state.customertype,
    };

    //  MasterService.createTenant(newtenant).then(() => this.props.navigate(`/tenants`))
    if (this.state.id === "") {
      CustomerService.createCustomer(newCustomer)
        .then((res) => {

          if (this.state.createledger) {
            let data = this.state.masterLedgers.find(e => e.mastertype === "Customer" && e.type === this.state.type)

            if (data) {
              let newpledgerreq = {
                name: values.companyname.trim().replace(" ", "_"),
                createdBy: userid,
                amount: this.state.amount,
                pledger: res.data.id,
                ledgroupid: data.ledgergroup.id,
                ledgroupname: data.ledgergroup.name,
                eledger: null,
                expenseid: null,
                expensename: null,
                assledid: null,
                assledname: null,
                subhead: data.subhead,
                tenantId: currentTenant,
                pan: "",
                date: null,
                receipt: 0,
                refund: 0,
                notetype: 0,
                taxtype: 0,
                partyledtype: 0,
              }

              NewLedgerService.createPartyLedger(newpledgerreq).then(() => {
                this.props.navigate({ pathname: "/customers" }, { state: { message: values.companyname + " and ledger created successfully." } })
              }).catch(() => {
                this.props.navigate({ pathname: "/customers" }, { state: { message: values.companyname + " created successfully but ledger creation failed, create customer ledger manually." } })
              })
            } else {
              this.props.navigate({ pathname: "/customers" }, { state: { message: values.companyname + " created successfully, create customer ledger manually." } })
            }
          } else {
            this.props.navigate({ pathname: "/customers" }, { state: { message: values.companyname + " created successfully." } })
          }


          // this.props.navigate(`/customers`, {
          //     message: values.companyname + "   : Created Successfully",
          //   })
        })
        .catch((error) => {
          if (error.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
          this.setState({
            error: error.response.data.message,
            loader: false,
          })
        }
        );
    } else {
      CustomerService.updateCustomer(updateCustomer).then(() =>
        this.props.navigate({ pathname: "/customers" }, {
          state: { message: values.companyname + "   : Updated Successfully" }
        })
      )
        .catch((e) => {
          if (e.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
        })
    }
  }

  handleCurrency = (value, values) => {
    if (values !== '' && typeof values === 'object' && values !== null) {
      this.setState({ currencyid: values.id, currency: values.currency })
    } else {
      this.setState({ currencyid: '', currency: '' })
    }
  }

  // handleTaxTypeChange=(e)=>{
  //   this.setState({ taxtype: e.target.value,});
  // }

  handleRegistrationTypeChange = (e) => {
    this.setState({ registrationtype: e.target.value, validgstin: false });
  }

  validateGSTIN = () => {

    if (this.state.gstvaldloader === false) {
      let data = {
        tenantId: currentTenant,
        reqparam: this.state.gstin.trim(),
      }
      this.setState({ gstvaldloader: true });

      SalesServices.validateGSTIN(data).then((response) => {
        this.setState({ gstvaldloader: false })
        if (response.data.body === null || response.data.body.statusCodeValue === 400) {
          Swal.fire({
            title: `Invalid GSTIN`,
            text: ".",
            icon: "error",
            confirmButtonText: "Ok",
            confirmButtonColor: "#152f5f",
          })
        } else {
          this.setState({ gstvaldloader: false, validgstin: true, pan: this.state.gstin.substring(2, 12) })
        }
      }
      ).catch(() => this.setState({ gstvaldloader: false }))
    }
  }

  fetchLedgerGroups = () => {
    SubHeadsService.getLedGroups(currentTenant).then((res) => {
      this.setState({ ledGroups: res.data })
      this.fetch(res.data)
    }).catch(() => {
      this.setState({ ledGroups: [] })
    })
  }
  fetch = (data) => {
    SettingsServices.getAllMasterLedgerMapping(currentTenant).then((res) => {
      let masterdata = []
      masterdata = res.data.map(e => { return { ...e, ledgergroup: data.find(l => l.id === e.ledgergroup) } })
      this.setState({ masterLedgers: [...masterdata] })
    })
  }

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }

    CustomerService.getCountries().then((response) =>
      this.setState({
        CountryData: response.data,
      })
    );

    MasterService.GetAllCurrency().then((response) => {
      this.setState({ currencylist: response.data })
    });

    // MasterService.getTaxtypes().then((response) =>
    //   this.setState({
    //     TaxtypeData: response.data,
    //   })
    // );

    SettingsServices.geteinvoicecredentials(currentTenant).then((response) => {
      this.setState({
        einvoice: response?.data?.status === "ACTIVE" ? true : false,
      });
    });
    this.fetchLedgerGroups()

    const { id } = this.props.location.state;

    //let {id} = this.props.location.state
    if (id < 1) {
      //  this.setState({id:id})
      return;
    }
    CustomerService.retriveCustomer(id).then((response) =>
      this.setState({
        id: response.data.id,
        companyname: response.data.companyname,
        contactname: response.data.contactname,
        prefix: response.data.prefix,
        contactnumber: response.data.contactnumber,
        email: response.data.email,
        address: response.data.address,
        address2: response.data.address2,
        pan: response.data.pan,
        gstin: response.data.gstin,
        zip: response.data.zip,
        CountryId: response.data.country,
        StateId: response.data.state,
        CityId: response.data.city,
        country: response.data.countryname,
        state: response.data.statename,
        city: response.data.cityname,
        currency: response.data.currency,
        alternatenumber: response.data.alternatenumber,
        customcustomerid: response.data.customcustomerid,
        phonecode: response.data.phonecode,
        taxtype: response.data.taxtype,
        registrationtype: response.data.registrationtype,
        statecode: response.data.states.code,
        ledgerid: response.data.ledgerid
      })
    );
  }

  ChangeCountry = (value, values) => {
    if (values !== '' && typeof values === 'object' && values !== null) {
      this.setState({ country: values.name, CountryId: values.id, phonecode: values.phonecode, state: '', StateId: '', city: '', CityId: '', CityData: [] });
      CustomerService.getStates(values.id).then((response) => {
        this.setState({
          StateData: response.data,
        });
      });
    } else {
      this.setState({
        country: '', CountryId: '', state: '', StateData: [], CityData: [], StateId: '', city: '', CityId: ''
      })
    }
  };
  ChangeState = (value, values) => {
    if (values !== '' && typeof values === 'object' && values !== null) {
      this.setState({ state: values.name, StateId: values.id, statecode: values.code });
      CustomerService.getCities(values.id).then((response) => {
        this.setState({
          CityData: response.data, city: '', CityId: ''
        });
      });
    } else {
      this.setState({
        state: '', StateId: '', city: '', CityId: ''
      })
    }
  };

  handleCity = (value, values) => {
    if (values !== '' && typeof values === 'object' && values !== null) {
      this.setState({ city: values.name, CityId: values.id })
    } else {
      this.setState({ city: '', CityId: '' })
    }
  }

  validate(values) {
    let errors = {};
    var num = /^[0-9]+$/;
    if (!values.companyname) {
      errors.companyname = "Company Name is required";
    }
    //  else if (!chars.test(values.companyname)) {
    //   errors.companyname = "Only Characters are allowed";
    // }
    if (!values.contactname) {
      errors.contactname = "Contact Name is required";
    }
    // else if (!chars.test(values.contactname)) {
    //   errors.contactname = "Only Characters are allowed";
    // }

    if (!values.contactnumber) {
      errors.contactnumber = "Contact Number is required";
    }

    if (!this.state.phonecode) {
      errors.phonecode = "Phone code is required";
    }

    // else if (values.country === "India") {
    //   if (!/^[7-8-9][0-9]{9}$/i.test(values.contactnumber)) {
    //     errors.contactnumber = "Contact Number should be 10 Numbers";
    //   }
    // }


    if (!values.email) {
      errors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
    ) {
      errors.email = "Invalid email address";
    }
    if (!values.address) {
      errors.address = "Address is required";
    } else if (einvoice && values.address.length > 100) {
      errors.address = "Max 100 character";
    }
    if (!values.address2) {
      errors.address2 = "Area/Place is required";
    } else if (values.address2.length > 100) {
      errors.address2 = "Max 100 character";
    }

    if (this.state.country === 'India' && this.state.registrationtype === "Registered") {
      if (!values.gstin) {
        errors.gstin = "GSTIN is required";
      } else if (!/^[A-Z0-9]{15}$/i.test(values.gstin)) {
        errors.gstin = "Invalid GSTIN should be 15 Charactors EX: 22ABCDE1234F1Z5";
      } else if (
        !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z]{1}[A-Z0-9]{1}/i.test(
          values.gstin
        )
      ) {
        errors.gstin = "Invalid Ex: 22ABCDE1234F1Z5";
      }

      if (parseInt(values.gstin.substring(0, 2)) !== parseInt(this.state.statecode)) {
        errors.gstin = `Invalid GSTIN for state ${this.state.state}`;
      }
    }
    if (this.state.country === 'India') {
      if (!values.zip) {
        errors.zip = "Zip is required";
      } else if (!num.test(values.zip)) {
        errors.zip = "Only Numbers allowed";
      } else if (!/^[0-9]{5,6}$/i.test(values.zip)) {
        errors.zip = "Should be 5 or 6 Numbers";
      }
    } else {
      if (!values.zip || this.state.zip === '') {
        errors.zip = "PO Box No. is required";
      }
    }

    if (this.state.CountryId === "") {
      errors.country = "Please Select Country";
    }
    if (this.state.StateId === "") {
      errors.state = "Please Select State";
    }
    if (this.state.CityId === "") {
      errors.city = "Please Select City";
    }
    if (this.state.currency === "" || !values.currency) {
      errors.currency = "Please Select Currency";
    }



    return errors;
  }

  //  handleChange = (event) => {
  //     this.setState({
  //       ...this.state,
  //       value: event.target.value
  //     })
  //   }

  render() {
    // let countrypre = [this.state.countryprefix]

    let {
      id,
      companyname,
      contactname,
      contactnumber,
      email,
      address,
      address2,
      pan,
      gstin,
      zip,
      CountryData,
      StateData,
      CityData,
      country,
      state,
      city,
      statecode,
      currencylist,
      currency,
      alternatenumber,
    } = this.state;


    return (
      <div>
        <Header />
        <Menu />

        <div className="content-wrapper">
          <div className="UI-container">
            <div className="UI-header">
              <Breadcrumb breadcrumbs={[{ name: "Home", path: "/masters" }, { name: "Customers", path: "/customers" }, { name: this.state.name, path: null }]} />
            </div>
            <div className="text-center text-danger">{this.state.error}</div>
            <div className="UI-form-card">
              <Formik
                initialValues={{
                  id,
                  companyname,
                  contactname,
                  contactnumber,
                  email,
                  address,
                  address2,
                  pan,
                  gstin,
                  zip,
                  CountryData,
                  StateData,
                  CityData,
                  country,
                  state,
                  statecode,
                  city,
                  currencylist,
                  currency,
                  alternatenumber
                }}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}
              >
                {({ setFieldValue, values, errors }) => (
                  <Form autoComplete="off">
                    <Backdrop
                      sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                      open={this.state.gstvaldloader}
                    // onClick={handleClose}
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                    <div className="form-row">
                      <fieldset hidden className=" col-md-6">
                        <label>Id</label>
                        <Field
                          className="form-control"
                          type="text"
                          name="id"
                          placeholder="Id"
                        />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="companyname" label="Company Name" value={this.state.companyname} onChange={(e) => this.setState({ companyname: e.target.value })} error={errors?.companyname} required
                        />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="contactname" label="Contact Name" value={this.state.contactname} onChange={(e) => this.setState({ contactname: e.target.value })} error={errors?.contactname} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="email" name="email" label="Email Id" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} error={errors?.email} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="address" label="Address" value={this.state.address} onChange={(e) => this.setState({ address: e.target.value })} error={errors?.address} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="address2" label="Area/Place" value={this.state.address2} onChange={(e) => this.setState({ address2: e.target.value })} error={errors?.address2} required />
                      </fieldset>

                      <fieldset className=" col-md-4 m-0">
                        <AutoCompeteField id="country" name="country" options={CountryData} label="Select Country" value={this.state.country} labelKey={"name"} valueKey={"name"} onChange={this.ChangeCountry} error={errors?.country} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <AutoCompeteField id="state" name="state" options={StateData} label="Select State" value={this.state.state} labelKey={"name"} valueKey={"name"} onChange={this.ChangeState} error={errors?.state} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <AutoCompeteField id="city" name="city" options={CityData} label="Select City" value={this.state.city} labelKey={"name"} valueKey={"name"} onChange={this.handleCity} error={errors?.city} required />
                      </fieldset>
                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="zip" label={this.state.country === "India" ? "Zip/Pincode" : "PO BOX No."} value={this.state.zip} onChange={(e) => this.setState({ zip: e.target.value })} error={errors?.zip} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <PhoneInput label="Contact Number" phonecode={this.state.phonecode} phonenumber={this.state.contactnumber} onChange={(phoneCode, newNumber) => this.setState({ contactnumber: newNumber.replace(/[^0-9]+/ig, ""), phonecode: phoneCode })} numbererror={errors?.contactnumber} codeerror={errors?.phonecode} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <PhoneInput label="Alternate Number" phonecode={this.state.alternatephonecode} phonenumber={this.state.alternatenumber} onChange={(phoneCode, newNumber) => this.setState({ alternatenumber: newNumber.replace(/[^0-9]+/ig, ""), alternatephonecode: phoneCode })} />
                      </fieldset>
                      <fieldset className=" col-md-4">
                        <AutoCompeteField id="currency" name="currency" options={currencylist} label="Select Currency" value={this.state.currency} labelKey={"currency"} valueKey={"currency"} onChange={this.handleCurrency} error={errors?.currency} required />
                      </fieldset>
                      {/* <fieldset className=" col-md-4 m-0">
                                <FormControl variant="standard" className="w-100">
                                  <InputLabel id="demo-simple-select-standard-label">Tax Type</InputLabel>
                                  <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={this.state.taxtype}
                                    onChange={this.handleTaxTypeChange}
                                    label="Tax Type"
                                  >
                                    {this.state.TaxtypeData.map((e,i)=>{
                                      return (
                                      <MenuItem value={e.type} key={i}>{e.type}</MenuItem>)
                                    })}
                                   
                                  </Select>
                                </FormControl>
                                </fieldset> */}

                      {/* <fieldset className=" col-md-12 m-0"/> */}
                      {/* <fieldset className=" col-md-3 mt-2">
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={this.state.registrationtype}
                                          onChange={() =>
                                            this.setState({
                                              registrationtype: !this.state.registrationtype,
                                            })
                                          }
                                          name="ordertype"
                                          color="primary"
                                          // disabled={this.state.orderfrom === 1}
                                        />
                                      }
                                      label="Tax Registered?"
                                    />
                                  </fieldset> */}
                      {this.state.country === "India" ?
                        <fieldset className=" col-md-4 m-0">
                          <SelectField label="Registration Type" lableKey={"type"} list={this.state.Registrationtypes} lableValue={"type"} value={this.state.registrationtype} onChange={this.handleRegistrationTypeChange} />
                        </fieldset>
                        : ''}

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="gstin" label={this.state.country === "India" ? "GSTIN" : "GSTIN / VAT No."} value={this.state.gstin} onChange={(e) => this.setState({ gstin: e.target.value?.trim().toUpperCase(), error: '', validgstin: false })} error={errors?.gstin} required />
                      </fieldset>
                      {this.state.country === "India" ?
                        <fieldset className=" col-md-4">
                          <TextfieldComponent type="text" name="pan" label="PAN" value={this.state.pan} onChange={(e) => this.setState({ pan: e.target.value })} error={errors?.pan} required />
                        </fieldset> : ''}

                      <fieldset className=" col-md-4 m-0">
                        <SelectField label="Customer Type" lableKey={null} list={["Regular", "Corporate", "Agency"]} lableValue={null} value={this.state.customertype} onChange={(e) => this.setState({ customertype: e.target.value })} />
                      </fieldset>


                      <div className=" col-md-12" />
                      {accounts === "YES" && (!this.state.ledgerid) && <>
                        <div className="">
                          <FormGroup row>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={this.state.createledger}
                                  onChange={(e) => this.setState({ createledger: e.target.checked })}
                                  name="createledger"
                                  color="primary"
                                />
                              }
                              label="Create Ledger"
                            />
                          </FormGroup>
                        </div>
                        {this.state.createledger && <div>
                          <SelectField label="Registration Type" lableKey={null} list={this.state.types} lableValue={null} value={this.state.type} onChange={(e) => this.setState({ type: e.target.value })} />
                        </div>}
                      </>}
                      <fieldset className=" col-md-12 tw-flex tw-justify-end">
                        {
                          einvoice && this.state.einvoice && this.state.country === 'India' && this.state.registrationtype === "Registered" && this.state.validgstin === false ?
                            <span className="UI-btn UI-btn-primary mr-1" onClick={this.validateGSTIN}>Validate GSTIN
                            </span>
                            :
                            this.state.loader === true ? (
                              <button className="UI-btn UI-btn-primary mr-1 " disabled>
                                <Spinner animation="border" size="sm" />
                                &nbsp;{"Saving"}
                              </button>
                            ) : (
                              <button className="UI-btn UI-btn-primary mr-1" type="submit">Save</button>
                            )}
                        <Link
                          as="button"
                          className="UI-btn UI-btn-outline"
                          to={{ pathname: "/customers" }}
                          state={{ message: "" }}
                        >Cancel</Link>
                      </fieldset>

                    </div>
                    {/* <Link as="button" type="submit" className="btn btn-success" to={{pathname: '/ledgers' }} state ={ {message:this.state.message}}}>Save</Link> */}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        {/* /.card-header */}
        {/* form start */}

        <Footer />
      </div>
    );
  }
}
export default withRouter(NewCustomer);
